export default __webpack_public_path__ + "static/media/rollupjs.82956976.svg";